import { IRA_ACCOUNT_TYPES } from '@ovComponents/4-module/workflowCompletion/constants/accounts';
import dayjs, { type Dayjs } from 'dayjs';

type DepositAccountConfig = { endOfPriorFiscalYear: Dayjs };
type DepositAccountConfigMap = { [accountType: string]: DepositAccountConfig };

export const depositAccountConfig = (
  currentDay?: string | Date,
): DepositAccountConfigMap => {
  const endOfPriorFiscalYear = (currentDay ? dayjs(currentDay) : dayjs())
    .date(15)
    .month(3)
    .endOf('day');

  return Object.fromEntries(
    IRA_ACCOUNT_TYPES.map((accountType) => [
      accountType,
      { endOfPriorFiscalYear },
    ]),
  );
};

export const showFiscalYearBasedOnAccountType = (accountType?: string) => {
  const config =
    depositAccountConfig()[
      accountType as keyof ReturnType<typeof depositAccountConfig>
    ];
  if (config) return true;
  return false;
};
